export default function CustomButtonIcon() {
  return <svg className="buy-icon" xmlns="http://www.w3.org/2000/svg" width="38" height="34" viewBox="0 0 38 34">
    <g fill="none" fillRule="evenodd">
      <path stroke="currentColor" d="M.7870039 2.59301758h6.9136797l3.7205137 22.89656932 22.3489443.012" strokeLinecap="round" strokeLinejoin="round"/>
      <path stroke="currentColor" d="M28.0140389 4.49572754h9.017334L34.1188973 19.4727783H11.0089119" strokeLinecap="round" strokeLinejoin="round"/>
      <path stroke="currentColor" d="M15.002193 28.5c1.3971616 0 2.502193 1.1042242 2.502193 2.5s-1.1050314 2.5-2.502193 2.5S12.5 32.3957758 12.5 31s1.1050314-2.5 2.502193-2.5zM27.5 31c0-1.3957758 1.1050314-2.5 2.502193-2.5s2.502193 1.1042242 2.502193 2.5-1.1050314 2.5-2.502193 2.5S27.5 32.3957758 27.5 31z"/>
      <path fill="currentColor" d="M23 .50625185V11.4270815c0 .2795952-.2319336.5062518-.5.5062518-.2761424 0-.5-.2261351-.5-.5062518V.50625185C22 .22665667 22.2319336 0 22.5 0c.2761424 0 .5.2261351.5.50625185zM8 4h9v1H8z"/>
      <path fill="currentColor" d="M25.53553353 8.0000001l.7071068.7071068-3.53553392 3.5355339-.70710676-.7071068z"/>
      <path fill="currentColor" d="M19.0000001 8.70710647l.7071068-.7071068 3.5355339 3.53553392-.7071068.70710676z"/>
    </g>
  </svg>
}



// WEBPACK FOOTER //
// ./components/item/buttons/customButtonIcon.js